import ValidTransactionInquiryFilterForm from '@Modules/admin/archiving/components/forms/archivedTables/validTransactionInquiry/ValidTransactionInquiryFilterForm';
import validTransactionInquiryFilterFormMeta from './ValidTransactionInquiryFilterFormMeta';

export type TValidTransactionInquiryFilterFormData = {
  acquiringBank: string;
  emitterBank: string;
  transactionCode: string;
  referenceNumber: string;
  carrierNumber: string;
  startTransactionDate: string;
  endTransactionDate: string;
};

type Props = {
  setFilterFormData: React.Dispatch<React.SetStateAction<TValidTransactionInquiryFilterFormData | null>>
}

const ValidTransactionInquiryFilterFormHandler: React.FC<Props> = ({setFilterFormData}) => {
   
  const onSubmit = async (payload: TValidTransactionInquiryFilterFormData) => {
    console.log('payload: ', payload);
    setFilterFormData(payload);
  };

  return <ValidTransactionInquiryFilterForm meta={validTransactionInquiryFilterFormMeta} onSubmit={onSubmit} />;
};

export default ValidTransactionInquiryFilterFormHandler;
